/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CloneEmailDocumentSectionDto,
  CreateEmailDocumentSectionDto,
  CreateRawEmailDocumentSectionDto,
  DeletedResponseDto,
  EmailDocumentSectionListResponseDto,
  EmailDocumentSectionResponseDto,
  EmailDocumentSectionSearchResponseDto,
  EmailDocumentSectionsControllerCreateParams,
  EmailDocumentSectionsControllerListParams,
  EmailDocumentSectionsControllerSearchParams,
  RenderSectionRequestDto,
  RenderSectionResponseDto,
  SectionSceneFrameRequestDto,
  SectionSceneFrameResponseDto,
  SendSectionTestEmailDto,
  SendTestEmailResponseDto,
  UpdateEmailDocumentSectionDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Wrap the section's rawHtml in a complete email document with brand merge tags resolved. Used by the preview modal so the user sees real colors/fonts instead of literal $brand.* tokens.
 */
export const sectionTestingControllerRender = (
  orgId: string,
  clientId: string,
  sectionId: string,
  renderSectionRequestDto: RenderSectionRequestDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<RenderSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/sections/${sectionId}/testing/render`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: renderSectionRequestDto,
      signal,
    },
    options
  );
};

export const getSectionTestingControllerRenderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sectionTestingControllerRender>>,
    TError,
    { orgId: string; clientId: string; sectionId: string; data: RenderSectionRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sectionTestingControllerRender>>,
  TError,
  { orgId: string; clientId: string; sectionId: string; data: RenderSectionRequestDto },
  TContext
> => {
  const mutationKey = ['sectionTestingControllerRender'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sectionTestingControllerRender>>,
    { orgId: string; clientId: string; sectionId: string; data: RenderSectionRequestDto }
  > = (props) => {
    const { orgId, clientId, sectionId, data } = props ?? {};

    return sectionTestingControllerRender(orgId, clientId, sectionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SectionTestingControllerRenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof sectionTestingControllerRender>>
>;
export type SectionTestingControllerRenderMutationBody = RenderSectionRequestDto;
export type SectionTestingControllerRenderMutationError = unknown;

/**
 * @summary Wrap the section's rawHtml in a complete email document with brand merge tags resolved. Used by the preview modal so the user sees real colors/fonts instead of literal $brand.* tokens.
 */
export const useSectionTestingControllerRender = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sectionTestingControllerRender>>,
      TError,
      { orgId: string; clientId: string; sectionId: string; data: RenderSectionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sectionTestingControllerRender>>,
  TError,
  { orgId: string; clientId: string; sectionId: string; data: RenderSectionRequestDto },
  TContext
> => {
  const mutationOptions = getSectionTestingControllerRenderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Send a test email containing this section. Same rate limit as template send-test (10/10min/client).
 */
export const sectionTestingControllerSendTest = (
  orgId: string,
  clientId: string,
  sectionId: string,
  sendSectionTestEmailDto: SendSectionTestEmailDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SendTestEmailResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/sections/${sectionId}/testing/send-test`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendSectionTestEmailDto,
      signal,
    },
    options
  );
};

export const getSectionTestingControllerSendTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sectionTestingControllerSendTest>>,
    TError,
    { orgId: string; clientId: string; sectionId: string; data: SendSectionTestEmailDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sectionTestingControllerSendTest>>,
  TError,
  { orgId: string; clientId: string; sectionId: string; data: SendSectionTestEmailDto },
  TContext
> => {
  const mutationKey = ['sectionTestingControllerSendTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sectionTestingControllerSendTest>>,
    { orgId: string; clientId: string; sectionId: string; data: SendSectionTestEmailDto }
  > = (props) => {
    const { orgId, clientId, sectionId, data } = props ?? {};

    return sectionTestingControllerSendTest(orgId, clientId, sectionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SectionTestingControllerSendTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sectionTestingControllerSendTest>>
>;
export type SectionTestingControllerSendTestMutationBody = SendSectionTestEmailDto;
export type SectionTestingControllerSendTestMutationError = unknown;

/**
 * @summary Send a test email containing this section. Same rate limit as template send-test (10/10min/client).
 */
export const useSectionTestingControllerSendTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sectionTestingControllerSendTest>>,
      TError,
      { orgId: string; clientId: string; sectionId: string; data: SendSectionTestEmailDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sectionTestingControllerSendTest>>,
  TError,
  { orgId: string; clientId: string; sectionId: string; data: SendSectionTestEmailDto },
  TContext
> => {
  const mutationOptions = getSectionTestingControllerSendTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Semantic search over sections visible to this client (system + org + client)
 */
export const emailDocumentSectionsControllerSearch = (
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionSearchResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/search`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerSearchQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: EmailDocumentSectionsControllerSearchParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEmailDocumentSectionsControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailDocumentSectionsControllerSearchQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>
  > = ({ signal }) =>
    emailDocumentSectionsControllerSearch(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailDocumentSectionsControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>
>;
export type EmailDocumentSectionsControllerSearchQueryError = unknown;

export function useEmailDocumentSectionsControllerSearch<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerSearch<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerSearch<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Semantic search over sections visible to this client (system + org + client)
 */

export function useEmailDocumentSectionsControllerSearch<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: EmailDocumentSectionsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailDocumentSectionsControllerSearchQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List sections visible to this client (system + org + client)
 */
export const emailDocumentSectionsControllerList = (
  orgId: string,
  clientId: string,
  params?: EmailDocumentSectionsControllerListParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerListQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: EmailDocumentSectionsControllerListParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEmailDocumentSectionsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentSectionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailDocumentSectionsControllerListQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>> = ({
    signal,
  }) => emailDocumentSectionsControllerList(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailDocumentSectionsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>
>;
export type EmailDocumentSectionsControllerListQueryError = unknown;

export function useEmailDocumentSectionsControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params: undefined | EmailDocumentSectionsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentSectionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentSectionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List sections visible to this client (system + org + client)
 */

export function useEmailDocumentSectionsControllerList<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  params?: EmailDocumentSectionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailDocumentSectionsControllerListQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new client-scoped section
 */
export const emailDocumentSectionsControllerCreate = (
  orgId: string,
  clientId: string,
  createEmailDocumentSectionDto: CreateEmailDocumentSectionDto,
  params?: EmailDocumentSectionsControllerCreateParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEmailDocumentSectionDto,
      params,
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>,
    TError,
    {
      orgId: string;
      clientId: string;
      data: CreateEmailDocumentSectionDto;
      params?: EmailDocumentSectionsControllerCreateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>,
  TError,
  {
    orgId: string;
    clientId: string;
    data: CreateEmailDocumentSectionDto;
    params?: EmailDocumentSectionsControllerCreateParams;
  },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>,
    {
      orgId: string;
      clientId: string;
      data: CreateEmailDocumentSectionDto;
      params?: EmailDocumentSectionsControllerCreateParams;
    }
  > = (props) => {
    const { orgId, clientId, data, params } = props ?? {};

    return emailDocumentSectionsControllerCreate(orgId, clientId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>
>;
export type EmailDocumentSectionsControllerCreateMutationBody = CreateEmailDocumentSectionDto;
export type EmailDocumentSectionsControllerCreateMutationError = unknown;

/**
 * @summary Create a new client-scoped section
 */
export const useEmailDocumentSectionsControllerCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>,
      TError,
      {
        orgId: string;
        clientId: string;
        data: CreateEmailDocumentSectionDto;
        params?: EmailDocumentSectionsControllerCreateParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreate>>,
  TError,
  {
    orgId: string;
    clientId: string;
    data: CreateEmailDocumentSectionDto;
    params?: EmailDocumentSectionsControllerCreateParams;
  },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get a single section visible to this client
 */
export const emailDocumentSectionsControllerGetOne = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerGetOneQueryKey = (
  orgId?: string,
  clientId?: string,
  id?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}`,
  ] as const;
};

export const getEmailDocumentSectionsControllerGetOneQueryOptions = <
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmailDocumentSectionsControllerGetOneQueryKey(orgId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>
  > = ({ signal }) =>
    emailDocumentSectionsControllerGetOne(orgId, clientId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailDocumentSectionsControllerGetOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>
>;
export type EmailDocumentSectionsControllerGetOneQueryError = unknown;

export function useEmailDocumentSectionsControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailDocumentSectionsControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single section visible to this client
 */

export function useEmailDocumentSectionsControllerGetOne<
  TData = Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailDocumentSectionsControllerGetOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailDocumentSectionsControllerGetOneQueryOptions(
    orgId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a tenant-scoped section
 */
export const emailDocumentSectionsControllerUpdate = (
  orgId: string,
  clientId: string,
  id: string,
  updateEmailDocumentSectionDto: UpdateEmailDocumentSectionDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEmailDocumentSectionDto,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>,
    TError,
    { orgId: string; clientId: string; id: string; data: UpdateEmailDocumentSectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateEmailDocumentSectionDto },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>,
    { orgId: string; clientId: string; id: string; data: UpdateEmailDocumentSectionDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return emailDocumentSectionsControllerUpdate(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>
>;
export type EmailDocumentSectionsControllerUpdateMutationBody = UpdateEmailDocumentSectionDto;
export type EmailDocumentSectionsControllerUpdateMutationError = unknown;

/**
 * @summary Update a tenant-scoped section
 */
export const useEmailDocumentSectionsControllerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>,
      TError,
      { orgId: string; clientId: string; id: string; data: UpdateEmailDocumentSectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerUpdate>>,
  TError,
  { orgId: string; clientId: string; id: string; data: UpdateEmailDocumentSectionDto },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete or deactivate a tenant-scoped section
 */
export const emailDocumentSectionsControllerRemove = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeletedResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}`,
      method: 'DELETE',
    },
    options
  );
};

export const getEmailDocumentSectionsControllerRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return emailDocumentSectionsControllerRemove(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>
>;

export type EmailDocumentSectionsControllerRemoveMutationError = unknown;

/**
 * @summary Delete or deactivate a tenant-scoped section
 */
export const useEmailDocumentSectionsControllerRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerRemove>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Mark this tenant-scoped section as the active default for its category. Only header / footer categories are defaultable.
 */
export const emailDocumentSectionsControllerSetAsDefault = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}/set-as-default`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerSetAsDefaultMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerSetAsDefault'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return emailDocumentSectionsControllerSetAsDefault(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerSetAsDefaultMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>
>;

export type EmailDocumentSectionsControllerSetAsDefaultMutationError = unknown;

/**
 * @summary Mark this tenant-scoped section as the active default for its category. Only header / footer categories are defaultable.
 */
export const useEmailDocumentSectionsControllerSetAsDefault = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerSetAsDefault>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerSetAsDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clone a system-scoped section into this client and mark it the active default for its category. The picker uses this so the brand lands with edit-able copies in their own library, separate from the seed catalog.
 */
export const emailDocumentSectionsControllerCloneAndSetDefault = (
  orgId: string,
  clientId: string,
  id: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}/clone-and-set-default`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerCloneAndSetDefaultMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>,
    TError,
    { orgId: string; clientId: string; id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerCloneAndSetDefault'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>,
    { orgId: string; clientId: string; id: string }
  > = (props) => {
    const { orgId, clientId, id } = props ?? {};

    return emailDocumentSectionsControllerCloneAndSetDefault(orgId, clientId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerCloneAndSetDefaultMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>
>;

export type EmailDocumentSectionsControllerCloneAndSetDefaultMutationError = unknown;

/**
 * @summary Clone a system-scoped section into this client and mark it the active default for its category. The picker uses this so the brand lands with edit-able copies in their own library, separate from the seed catalog.
 */
export const useEmailDocumentSectionsControllerCloneAndSetDefault = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>,
      TError,
      { orgId: string; clientId: string; id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCloneAndSetDefault>>,
  TError,
  { orgId: string; clientId: string; id: string },
  TContext
> => {
  const mutationOptions =
    getEmailDocumentSectionsControllerCloneAndSetDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clone a system-scoped section into this client, optionally flattening it to chat-editable HTML. Backs the "start from a prebuilt" gallery: unlike clone-and-set-default, the caller chooses whether the copy stays a structured node row or becomes an html row the agent can rewrite conversationally.
 */
export const emailDocumentSectionsControllerClone = (
  orgId: string,
  clientId: string,
  id: string,
  cloneEmailDocumentSectionDto: CloneEmailDocumentSectionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}/clone`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloneEmailDocumentSectionDto,
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerCloneMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>,
    TError,
    { orgId: string; clientId: string; id: string; data: CloneEmailDocumentSectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>,
  TError,
  { orgId: string; clientId: string; id: string; data: CloneEmailDocumentSectionDto },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerClone'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>,
    { orgId: string; clientId: string; id: string; data: CloneEmailDocumentSectionDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return emailDocumentSectionsControllerClone(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerCloneMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>
>;
export type EmailDocumentSectionsControllerCloneMutationBody = CloneEmailDocumentSectionDto;
export type EmailDocumentSectionsControllerCloneMutationError = unknown;

/**
 * @summary Clone a system-scoped section into this client, optionally flattening it to chat-editable HTML. Backs the "start from a prebuilt" gallery: unlike clone-and-set-default, the caller chooses whether the copy stays a structured node row or becomes an html row the agent can rewrite conversationally.
 */
export const useEmailDocumentSectionsControllerClone = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>,
      TError,
      { orgId: string; clientId: string; id: string; data: CloneEmailDocumentSectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerClone>>,
  TError,
  { orgId: string; clientId: string; id: string; data: CloneEmailDocumentSectionDto },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerCloneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create a tenant-scoped section from a raw HTML fragment. Used by the onboarding "Paste HTML" path and by ESP-extraction sync jobs. HTML is sanitized server-side. v1 only accepts format=html; mjml is reserved.
 */
export const emailDocumentSectionsControllerCreateRaw = (
  orgId: string,
  clientId: string,
  createRawEmailDocumentSectionDto: CreateRawEmailDocumentSectionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailDocumentSectionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/raw`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRawEmailDocumentSectionDto,
      signal,
    },
    options
  );
};

export const getEmailDocumentSectionsControllerCreateRawMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>,
    TError,
    { orgId: string; clientId: string; data: CreateRawEmailDocumentSectionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>,
  TError,
  { orgId: string; clientId: string; data: CreateRawEmailDocumentSectionDto },
  TContext
> => {
  const mutationKey = ['emailDocumentSectionsControllerCreateRaw'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>,
    { orgId: string; clientId: string; data: CreateRawEmailDocumentSectionDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return emailDocumentSectionsControllerCreateRaw(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailDocumentSectionsControllerCreateRawMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>
>;
export type EmailDocumentSectionsControllerCreateRawMutationBody = CreateRawEmailDocumentSectionDto;
export type EmailDocumentSectionsControllerCreateRawMutationError = unknown;

/**
 * @summary Create a tenant-scoped section from a raw HTML fragment. Used by the onboarding "Paste HTML" path and by ESP-extraction sync jobs. HTML is sanitized server-side. v1 only accepts format=html; mjml is reserved.
 */
export const useEmailDocumentSectionsControllerCreateRaw = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>,
      TError,
      { orgId: string; clientId: string; data: CreateRawEmailDocumentSectionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof emailDocumentSectionsControllerCreateRaw>>,
  TError,
  { orgId: string; clientId: string; data: CreateRawEmailDocumentSectionDto },
  TContext
> => {
  const mutationOptions = getEmailDocumentSectionsControllerCreateRawMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Convert a structured library section into an editable canvas frame (auto-layout SceneDocument), brand/slot tokens resolved to literals. Live-eligible frames come back pinned to live MJML compile mode.
 */
export const sectionSceneFrameControllerToSceneFrame = (
  orgId: string,
  clientId: string,
  id: string,
  sectionSceneFrameRequestDto: SectionSceneFrameRequestDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SectionSceneFrameResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-document-sections/${id}/scene-frame`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sectionSceneFrameRequestDto,
      signal,
    },
    options
  );
};

export const getSectionSceneFrameControllerToSceneFrameMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>,
    TError,
    { orgId: string; clientId: string; id: string; data: SectionSceneFrameRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>,
  TError,
  { orgId: string; clientId: string; id: string; data: SectionSceneFrameRequestDto },
  TContext
> => {
  const mutationKey = ['sectionSceneFrameControllerToSceneFrame'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>,
    { orgId: string; clientId: string; id: string; data: SectionSceneFrameRequestDto }
  > = (props) => {
    const { orgId, clientId, id, data } = props ?? {};

    return sectionSceneFrameControllerToSceneFrame(orgId, clientId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SectionSceneFrameControllerToSceneFrameMutationResult = NonNullable<
  Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>
>;
export type SectionSceneFrameControllerToSceneFrameMutationBody = SectionSceneFrameRequestDto;
export type SectionSceneFrameControllerToSceneFrameMutationError = unknown;

/**
 * @summary Convert a structured library section into an editable canvas frame (auto-layout SceneDocument), brand/slot tokens resolved to literals. Live-eligible frames come back pinned to live MJML compile mode.
 */
export const useSectionSceneFrameControllerToSceneFrame = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>,
      TError,
      { orgId: string; clientId: string; id: string; data: SectionSceneFrameRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sectionSceneFrameControllerToSceneFrame>>,
  TError,
  { orgId: string; clientId: string; id: string; data: SectionSceneFrameRequestDto },
  TContext
> => {
  const mutationOptions = getSectionSceneFrameControllerToSceneFrameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
